<div class="col-xs-12 col-md-9 col-lg-6 col-xl-6">
  <ng-content></ng-content>
</div>
